import { redirect } from '../helpers/url';
import ProductFilters from '../services/product-filters';
import clickAndCollect from '../services/click-and-collect';
import MicroModal from 'micromodal';
// TODO: Do wyczyszczenia/refactoringu w przyszłości, w trakcie modyfikacji strony promocyjnej, ponieważ ten plik
// wykorzystuje funkcje stworzone dla listy produktów a nie strony promocyjnej, mimo że jest tam użyty
const addSortProductListListener = () => {
    document.querySelectorAll('.product-list-page .sort-selector').forEach((elem) => {
        elem.addEventListener('change', (e) => {
            e.preventDefault();
            ProductFilters.filter();
        });
    });
    document.querySelectorAll('.promo-page .sort-selector').forEach((elem) => {
        elem.addEventListener('change', (e) => {
            e.preventDefault();
            const targetUrl = ProductFilters.getTargetUrl();
            if (targetUrl) {
                document.location.href = targetUrl;
            }
        });
    });
};
const addPerPageListener = () => {
    document
        .querySelectorAll('.result-list-products-pagination select.perpage-selector')
        .forEach((elem) => {
        elem.addEventListener('change', (e) => {
            e.preventDefault();
            ProductFilters.filter();
        });
    });
    document.querySelectorAll('.promo-page select.perpage-selector').forEach((elem) => {
        elem.addEventListener('change', (e) => {
            e.preventDefault();
            const targetUrl = ProductFilters.getTargetUrl();
            if (targetUrl) {
                document.location.href = targetUrl;
            }
        });
    });
};
const addAvailableInShopFilterListener = (filterForm) => {
    const availableInShopFilterLabel = filterForm.querySelector('.filter-available-in-shop__input label');
    if (!availableInShopFilterLabel) {
        return;
    }
    availableInShopFilterLabel.addEventListener('click', (e) => {
        e.preventDefault();
        if (availableInShopFilterLabel.parentElement) {
            const checkbox = availableInShopFilterLabel.parentElement.querySelector('input');
            if (!checkbox) {
                return;
            }
            checkbox.checked = !checkbox.checked;
            ProductFilters.filter();
        }
    });
};
const addFilterFormListener = (filterForm) => {
    if (filterForm) {
        filterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const targetUrl = ProductFilters.getTargetUrl();
            if (targetUrl) {
                document.location.href = targetUrl;
            }
        });
    }
};
const addFilterLabelListener = (filterForm) => {
    if (filterForm) {
        filterForm.querySelectorAll('.filter-element__label span').forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                if (elem.parentElement && elem.parentElement.dataset.url) {
                    redirect(elem.parentElement.dataset.url);
                }
            });
        });
    }
};
const initClickAndCollect = () => {
    const chooseShopElements = document.querySelectorAll('.cc-choose-shop');
    if (!chooseShopElements) {
        return;
    }
    chooseShopElements.forEach((chooseShop) => {
        chooseShop.addEventListener('click', (e) => {
            e.preventDefault();
            const remote = chooseShop.dataset.remote;
            const shopId = chooseShop.dataset.shopId;
            if (remote) {
                const formData = new FormData();
                formData.append('limit', '0');
                if (typeof shopId === 'string') {
                    formData.append('shopId', shopId);
                }
                fetch(remote, {
                    method: 'POST',
                    cache: 'no-cache',
                    body: formData,
                })
                    .then((response) => {
                    if (!response.ok) {
                        throw new Error('Unknown failure');
                    }
                    return response.text();
                })
                    .then((response) => {
                    const modalCCShops = document.querySelector('#modal-cc-shops');
                    if (modalCCShops) {
                        const modalCCShopsContent = modalCCShops.querySelector('.content');
                        if (modalCCShopsContent) {
                            modalCCShopsContent.innerHTML = response;
                        }
                        modalCCShops.dataset.remote = remote;
                        modalCCShops.dataset.shopId = shopId;
                        MicroModal.show('modal-cc-shops', {
                            disableScroll: true,
                            onClose: (modal, activeElement, event) => {
                                // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                                if (event !== null) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            },
                        });
                        clickAndCollect.initModal(modalCCShops);
                    }
                })
                    .catch((err) => {
                    console.error(err);
                });
            }
        });
    });
};
export default (baseUrl, featuresSeparator, valuesSeparator, translations, searchEngineMode = false, getParams = '', totalProducts = null, availableInShopFilter = false) => {
    const filterForm = document.querySelector('.filter__form');
    const priceFilter = document.querySelector('#price-slider');
    const priceMin = document.querySelector('#price-filter-min');
    const priceMax = document.querySelector('#price-filter-max');
    const priceTxtMin = document.querySelector('#price-lower-value');
    const priceTxtMax = document.querySelector('#price-upper-value');
    const sortSelect = document.querySelector('.sort-selector');
    const perPageSelector = document.querySelector('.result-list-products-pagination select.perpage-selector');
    ProductFilters.baseUrl = baseUrl;
    ProductFilters.featuresSeparator = featuresSeparator;
    ProductFilters.valuesSeparator = valuesSeparator;
    ProductFilters.translations = translations;
    ProductFilters.searchEngineMode = searchEngineMode;
    ProductFilters.getParams = getParams;
    ProductFilters.availableInShopFilter = availableInShopFilter;
    // Zdarzenie Google Analytics w przypadku braku wyników
    if (searchEngineMode && totalProducts === 0) {
        window.dispatchEvent(new CustomEvent('ga-event', {
            detail: {
                place: 'error',
                action: 'website_error',
                value1: 'zero_search',
            },
        }));
        window.dispatchEvent(new CustomEvent('ga4-event', {
            detail: {
                name: 'website_error',
                params: { type: 'zero_search' },
            },
        }));
    }
    if (filterForm) {
        addFilterFormListener(filterForm);
        addFilterLabelListener(filterForm);
        if (availableInShopFilter) {
            addAvailableInShopFilterListener(filterForm);
        }
    }
    ProductFilters.initElements(filterForm ? filterForm : undefined, sortSelect, perPageSelector);
    addSortProductListListener();
    addPerPageListener();
    if (availableInShopFilter) {
        window.addEventListener('selected-cc-shop', (data) => {
            const selectedShopElement = document.querySelector('#filter_checkbox_shop_available_id');
            if (selectedShopElement === null) {
                console.error('Missing store ID input #filter_checkbox_shop_available_id');
                return;
            }
            if (data.detail) {
                selectedShopElement.value = data.detail.shop.id.toFixed(0);
            }
            else {
                selectedShopElement.value = '';
            }
            ProductFilters.filter();
        });
        initClickAndCollect();
    }
    if (priceFilter && priceMin && priceMax && priceTxtMin && priceTxtMax) {
        ProductFilters.initSlider(priceFilter);
    }
};
